module.exports = __webpack_public_path__ + "img/new-04-thumbfly4.6daf6845.jpg";